module.exports = __webpack_public_path__ + "img/pause.a9f690e0.svg";